import { BCMSCurrency, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import StopPaymentPage, { getDefaultPageData } from "components/pages/StopPaymentPage";
import StopPayment from "components/workflows/StopPaymentsWorkflow/classes/StopPayment";
import Classes from "model";

export default function CaptureStopPaymentAmountEntered(props) {
    const context = useBCMSContext();
    const { branding } = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    
    let defaultData = getDefaultPageData(branding.options, context);
    let stopCheckCustomFields = defaultData.payment.stopCheckCustomFields;
    stopCheckCustomFields = StopPayment.setCustomFieldValue(stopCheckCustomFields, "Check Number", "123");
    stopCheckCustomFields = StopPayment.setCustomFieldValue(stopCheckCustomFields, "Check Amount", BCMSCurrency.init(100));

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "payment", "stopCheckCustomFields"], stopCheckCustomFields)
    .submit();

    return <StopPaymentPage data={ data } />
}